<div mat-dialog-title>
  <div class="h4 mb-0">{{title}}</div>
  <button data-testId="close-create-dpr-date-picker" mat-icon-button (click)="onCancel()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div mat-dialog-content class="noPadding">
  <mat-card class="flex-row align-items-center mx-3 mt-3 mb-0 p-3 info-div">
    <mat-icon class="mr-2 icon--large" svgIcon="information-outline"></mat-icon>
    <div class="d-flex flex-column">
      <h4 class="mb-0" i18n="@@dpr.setupDprDateModal.txtSelectDprDate">Select the date for the new DPR</h4>
      <div i18n="@@dpr.setupDprDateModal.txtOnceCreatedCannotChange">Once created, the date cannot be changed</div>
    </div>
  </mat-card>

  <mat-calendar
    [(selected)]="selectedDate"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [startAt]="firstAvailableDate"
    [dateFilter]="filterAvailableDates"
    (viewChanged)="clearSelectedDate()"
  ></mat-calendar>
</div>

<div mat-dialog-actions class="d-flex">
  <button data-testId="create-dpr" mat-flat-button color="primary" [disabled]="!selectedDate" (click)="onCreateDpr()">
    <mat-icon svgIcon="check"></mat-icon>
    <span i18n="@@dpr.setupDprDateModal.btnCreateDpr">Create DPR</span>
  </button>
  <button mat-button color="primary" data-testId="cancel-create-dpr-date-picker" (click)="onCancel()">
    {{StaticMessage.CancelButton | staticMessage}}
  </button>
</div>
